<div class="datepicker-dialog-container">
  <!-- Top Titles -->
  <div class="datepicker-top-titles">
    <span class="title-left">{{ 'home.labels.startDate' | translate }}</span>
    <span class="title-right">{{ 'home.labels.endDate' | translate }}</span>
  </div>

  <div class="calendars-wrapper">
    <div class="month-container" *ngFor="let month of months; let first = first; let last = last">
      <!-- Month Header Bar -->
      <div class="month-header-bar">
        <button type="button" class="nav-btn prev" *ngIf="first" (click)="navigateMonth(-1)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <span class="month-name-year">{{ month.name }} {{ month.year }}</span>
        <button type="button" class="nav-btn next" *ngIf="last" (click)="navigateMonth(1)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Weekday Headers -->
      <div class="weekdays-grid">
        <div class="weekday-header" *ngFor="let day of weekDays">{{ day }}</div>
      </div>

      <!-- Days Grid -->
      <div class="days-grid">
        <div 
          *ngFor="let day of month.days" 
          class="day-cell-holder"
          [class.empty-cell]="!day.dayNumber"
          [class.disabled-cell]="day.dayNumber && !day.isClickable"
          [class.in-range]="day.isInRange"
          [class.selected-start]="day.isSelectedStart"
          [class.selected-end]="day.isSelectedEnd"
          (click)="onDayClick(day)"
        >
          <div class="day-cell-content" *ngIf="day.dayNumber">
            <span class="day-text">{{ day.dayNumber }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Buttons -->
  <div class="action-buttons">
    <button type="button" class="btn-clear" (click)="clear()">{{ 'home.labels.clear' | translate }}</button>
    <div class="right-buttons">
      <button type="button" class="btn-cancel" (click)="cancel()">{{ 'home.labels.cancel' | translate }}</button>
      <button type="button" class="btn-apply" [disabled]="isApplyDisabled" (click)="apply()">{{ 'home.labels.apply' | translate }}</button>
    </div>
  </div>
</div>
